import { NavLink } from 'react-router-dom'
import { LogOut, X } from 'lucide-react'
import { navItems } from '@/data/navigation'
import { APP_NAME } from '@/utils/constants'
import { Badge } from '@/components/ui/Badge'
import styles from './Sidebar.module.css'

interface SidebarProps {
  isOpen: boolean
  onClose: () => void
}

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  return (
    <>
      {isOpen && (
        <button
          type="button"
          className={styles.overlay}
          aria-label="Close menu"
          onClick={onClose}
        />
      )}
      <aside
        className={[styles.sidebar, isOpen && styles.open]
          .filter(Boolean)
          .join(' ')}
      >
        <div className={styles.header}>
          <div className={styles.logo}>
            <div className={styles.logoIcon}>N</div>
            <span className={styles.logoText}>{APP_NAME}</span>
          </div>
          <button
            type="button"
            className={styles.closeBtn}
            aria-label="Close menu"
            onClick={onClose}
          >
            <X size={20} />
          </button>
        </div>

        <nav className={styles.nav} aria-label="Main navigation">
          <ul className={styles.navList}>
            {navItems.map(({ label, path, icon: Icon, badge }) => (
              <li key={path}>
                <NavLink
                  to={path}
                  end={path === '/'}
                  className={({ isActive }) =>
                    [styles.navLink, isActive && styles.active]
                      .filter(Boolean)
                      .join(' ')
                  }
                  onClick={onClose}
                >
                  <Icon size={18} className={styles.navIcon} />
                  <span>{label}</span>
                  {badge && (
                    <Badge variant="new" className={styles.badge}>
                      {badge}
                    </Badge>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.footer}>
          <button type="button" className={styles.logoutBtn}>
            <LogOut size={18} />
            <span>Logout</span>
          </button>
          <span className={styles.version}>v1.0.0</span>
        </div>
      </aside>
    </>
  )
}
